import React, { useEffect, useState } from 'react';
import DataContainer from 'Components/UI/DataContainer';
import useCollection from 'Hooks/useCollection';
import useSimpleHousehold from 'Hooks/useSimpleHousehold';
import { displayErrorMessage } from 'Helpers/FacetNotificationManager';
import { convertBalanceSheetCollectionToItems } from 'Helpers/BalanceSheet';
import fr from 'facet-rest';
import BalanceSheetView from './View';

const BalanceSheetContainer = (props) => {
  const { householdResource } = useSimpleHousehold();
  const { collection, setCollection } = useCollection();
  const [loading, setLoading] = useState(true);
  const [loadingError, setLoadingError] = useState(null);

  async function fetchData(hhResource) {
    try {
      const coll = await hhResource.relationship(fr.relationships.householdBalanceSheetLegacy.name).link('related').get();
      setCollection(coll);
    } catch (err) {
      setLoadingError(err);
    }
    setLoading(false);
  }

  useEffect(() => {
    if (householdResource) {
      fetchData(householdResource)
        .catch(err => displayErrorMessage(err, err.errors));
    }
  }, [householdResource]);

  return (
    <DataContainer
      backgroundColor="white"
      loading={loading}
      loadingError={loadingError}
      ErrorListProps={{
        title: 'An error occurred while loading the Balance Sheet',
      }}
      component={BalanceSheetView}
      componentProps={{
        data: convertBalanceSheetCollectionToItems(collection),
        ...props,
      }}
    />
  );
};

export default BalanceSheetContainer;
